import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Please enter your email address"),
  password: Yup.string()
    .required("Please enter your password")
    .min(8, "Password must be at least 8 characters long")
    .matches(/^(?=.*\d)/, "At least 1 numeric digit is required")
    .matches(/^(?=.*[A-Z])/, "At least 1 uppercase character is required")
    .matches(/^(?=.*[a-z])/, "At least 1 lowercase character is required")
    .matches(/^(?=.*[@$!%*?&])/, "At least 1 special character is required"),
});
